import React from 'react'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

function ReportGraphEssay({ data, title, type }) {

  const options = {
    chart: {
      type: type,
    },
    title: {
      text: title,
    },
    xAxis: data.data ? data.data.xAxis : '',
    yAxis: data.data ? data.data.yAxis : '',
    series: data.data ? data.data.series : '',
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default ReportGraphEssay